import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import {IntlShape} from 'react-intl';
import {parseTermsBlocks} from '../terms';
import QuotePage from './QuotePage';
import SectionLabel from './SectionLabel';
import {stylesFor} from './quotePdfStyles';
import type {QuoteDocumentData, QuoteTemplate} from '../resolver/types';
import {sectionBody} from '../persistence/quoteTemplateSchema';
import {sectionTitle} from '../config/defaultTemplate';

type QuoteTermsPageProps = {
	data: QuoteDocumentData;
	template: QuoteTemplate;
	intl: IntlShape;
};

/** Terms & conditions rendered as numbered term blocks (brand-colored numbers). */
const QuoteTermsPage = ({data, template, intl}: QuoteTermsPageProps): JSX.Element => {
	const styles = stylesFor(template);
	const terms = parseTermsBlocks(sectionBody(template, 'TERMS'));
	return (
		<QuotePage data={data} template={template} intl={intl}>
			<View style={styles.section}>
				<SectionLabel template={template}>{sectionTitle(template, 'TERMS', intl)}</SectionLabel>
				{terms.map((term, index) => (
					<View key={index} style={styles.termRow} wrap={false}>
						<Text style={[styles.termNumber, {color: template.branding.accentColor}]}>{index + 1}</Text>
						<View style={styles.termBody}>
							{term.heading ? <Text style={styles.termHeading}>{term.heading}</Text> : null}
							{term.body ? <Text style={styles.termText}>{term.body}</Text> : null}
						</View>
					</View>
				))}
			</View>
		</QuotePage>
	);
};

export default QuoteTermsPage;
